module.exports = __webpack_public_path__ + "img/AX.5738c3ed.svg";